import {DELETE_NEW_CYCLE_START} from "../../types";

export const delete_new_cycle = (payload) => ({
    type: DELETE_NEW_CYCLE_START,
    payload,
});
